/**
 * @generated SignedSource<<6820f5a3ea341697122040b9b853d96b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ToolCallButton_toolCall$data = {
  readonly toolResult: {
    readonly commandFailed: boolean | null | undefined;
    readonly hasData: boolean | null | undefined;
  } | null | undefined;
  readonly toolUse: {
    readonly capabilityId: number | null | undefined;
    readonly displayName: string | null | undefined;
    readonly input: {
      readonly __typename: "BuildkiteAnnotationsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "BuildkiteArtifactsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "BuildkiteBuildsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "BuildkiteFlakyTestToolInput";
      readonly question: string;
    } | {
      readonly __typename: "BuildkiteLogsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "CloudWatchLogsAggregationToolInput";
      readonly question: string;
    } | {
      readonly __typename: "CloudWatchLogsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "CloudWatchMetricsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogCIPipelineEventsAggregationToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogCIPipelineEventsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogErrorTrackingIssueDetailsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogErrorTrackingIssuesToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogEventsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogLogsAggregationToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogLogsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogMetricsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogMonitorToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogRumAggregationToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogServiceDependencyToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogSpansAggregationToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogSpansToolInput";
      readonly question: string;
    } | {
      readonly __typename: "GitHubActionsLogsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "GitHubActionsRunsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "GrafanaCloudLogsAggregationToolInput";
      readonly question: string;
    } | {
      readonly __typename: "GrafanaCloudLogsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "GrafanaCloudMetricsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "GrafanaCloudSpansAggregationToolInput";
      readonly question: string;
    } | {
      readonly __typename: "GrafanaCloudSpansToolInput";
      readonly question: string;
    } | {
      readonly __typename: "NewRelicLogsAggregationToolInput";
      readonly question: string;
    } | {
      readonly __typename: "NewRelicLogsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "NewRelicMetricsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "NewRelicSpansAggregationToolInput";
      readonly question: string;
    } | {
      readonly __typename: "NewRelicSpansToolInput";
      readonly question: string;
    } | {
      readonly __typename: "NewRelicTransactionsAggregationToolInput";
      readonly question: string;
    } | {
      readonly __typename: "NewRelicTransactionsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "QueryCodeToolInput";
      readonly question: string;
    } | {
      readonly __typename: "SentryIssueEventsToolInput";
      readonly issueId: string;
      readonly question: string;
    } | {
      readonly __typename: "SentryIssuesToolInput";
      readonly endIsoStr: string;
      readonly environment: string;
      readonly projectId: string;
      readonly question: string;
      readonly sentryQueryParams: string;
      readonly startIsoStr: string;
    } | {
      readonly __typename: "SlackChannelContentsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "SlackChannelMetadataToolInput";
      readonly question: string;
    } | {
      readonly __typename: "SlackUsergroupMentionToolInput";
      readonly usergroupHandle: string;
    } | {
      readonly __typename: "TemporalWorkflowHistoryToolInput";
      readonly question: string;
    } | {
      readonly __typename: "TemporalWorkflowsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "UpdateTodoToolInput";
      readonly tasks: ReadonlyArray<any>;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
    readonly name: string;
  } | null | undefined;
  readonly " $fragmentType": "ToolCallButton_toolCall";
};
export type ToolCallButton_toolCall$key = {
  readonly " $data"?: ToolCallButton_toolCall$data;
  readonly " $fragmentSpreads": FragmentRefs<"ToolCallButton_toolCall">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "question",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ToolCallButton_toolCall",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLMessageToolUse",
      "kind": "LinkedField",
      "name": "toolUse",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "capabilityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "input",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "DatadogLogsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "DatadogLogsAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "DatadogMetricsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "DatadogSpansToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "DatadogSpansAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "DatadogRumAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "DatadogEventsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "DatadogCIPipelineEventsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "DatadogCIPipelineEventsAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "DatadogMonitorToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "DatadogServiceDependencyToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "DatadogErrorTrackingIssueDetailsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "DatadogErrorTrackingIssuesToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "BuildkiteBuildsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "BuildkiteLogsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "BuildkiteAnnotationsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "BuildkiteArtifactsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "BuildkiteFlakyTestToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "CloudWatchLogsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "CloudWatchLogsAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "CloudWatchMetricsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "GrafanaCloudLogsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "GrafanaCloudLogsAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "GrafanaCloudMetricsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "GrafanaCloudSpansAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "GrafanaCloudSpansToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "NewRelicLogsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "NewRelicLogsAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "NewRelicMetricsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "NewRelicSpansToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "NewRelicSpansAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "NewRelicTransactionsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "NewRelicTransactionsAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "QueryCodeToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "GitHubActionsRunsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "GitHubActionsLogsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "SlackChannelContentsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "SlackChannelMetadataToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "usergroupHandle",
                  "storageKey": null
                }
              ],
              "type": "SlackUsergroupMentionToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "environment",
                  "storageKey": null
                },
                {
                  "alias": "sentryQueryParams",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "queryParams",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "SentryIssuesToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "issueId",
                  "storageKey": null
                }
              ],
              "type": "SentryIssueEventsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "TemporalWorkflowsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "TemporalWorkflowHistoryToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "tasks",
                  "storageKey": null
                }
              ],
              "type": "UpdateTodoToolInput",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLMessageToolResult",
      "kind": "LinkedField",
      "name": "toolResult",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasData",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "commandFailed",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLMessageToolCall",
  "abstractKey": null
};
})();

(node as any).hash = "d9aa1c88666edf3eba031416b25cc200";

export default node;
